import React from 'react'
import './Footer.css'

const Footer = (props) => {
  return (
    <footer className='Footer'>
      <div className='container flex' />
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/Footer/Footer.js